import { types } from "../types/types";
import { monedas } from "../../data";
import { forms } from "../../utils/flujoCaja";

export const setSidebarResponsive = (val) => ({
  type: types.set,
  payload: val,
});

export const getForms = (values) => ({
  type: types.getForms,
  payload: values,
});

export const importForms = () => {
  return async (dispatch) => {
    try {
      dispatch(getForms(forms));
    } catch (error) {
      console.error(error);
    }
  };
};
export const setCurrency = (val) => ({
  type: types.setCurrency,
  payload: val,
});

export const getMonedas = (val) => ({
  type: types.getCurrency,
  payload: val,
});

export const importMonedas = () => {
  return async (dispatch) => {
    try {
      dispatch(getMonedas(monedas));
    } catch (error) {
      console.error(error);
    }
  };
};

export const sendFormGeneric = (data, type) => {
  return async (dispatch) => {
    //Consumir api para enviar datos del formulario
    //Type indica de donde viene el formulario
  };
};
